import { DataTableFilter } from '@/types/DataTable'
import { DateTime, Interval } from 'luxon'
import { computed, Ref, ref } from 'vue'

interface DateIntervalFilterPayload {
  label: string
  field: string
  icon: string
  required: boolean
  initial: Date[] | null
}

export function useDateIntervalFilter({
  label,
  field,
  initial,
  required,
  icon,
}: DateIntervalFilterPayload): DataTableFilter<Date[]> {
  const loading = ref(false)

  const model: Ref<Date[] | null> = ref(initial)

  const ready = Promise.resolve(true)

  return {
    model,
    value: computed(() => {
      if (model.value?.length === 0) model.value = null
      if (model.value === null) return null

      return Interval.fromDateTimes(
        DateTime.fromJSDate(model.value[0]).set({ hour: 0, minute: 0 }),
        DateTime.fromJSDate(model.value[model.value.length - 1]).set({ hour: 23, minute: 59 }),
      ).toISO()
    }),
    label,
    field,
    type: 'date-interval',
    icon,
    loading,
    ready,
    required,
    clearable: true,
  }
}
